export default [
    // 充值
    {
        path: '/user/recharge',
        name: 'recharge',
        component: () => import("../views/user/recharge.vue")
    },
    // 支付
    {
        path: '/user/payment',
        name: 'payment',
        component: () => import("../views/user/payment.vue")
    },
    // 改名卡支付
    {
        path: '/user/renamingCard',
        name: 'renamingCard',
        component: () => import("../views/user/payment.vue")
    }
]
